import { Autocomplete, Chip, TextField } from '@mui/material';
import { ReactNode } from 'react';
import { useFormikContext } from 'formik';
import { Search } from 'react-feather';

// Components
import IconFeather from 'src/components/common/Icon';
import PaperSelect from 'src/components/common/PaperSelect';
import TooltipFormLabel from 'src/components/common/TooltipFormLabel';
import { REGION_PORTS } from 'src/utils/constants/regionPorts';
import { getFormItemError, renderFormItemError } from 'src/utils/helpers/renderFormItemError';

interface IProps {
  id: string;
  tooltipText?: string;
  required?: boolean;
  label?: ReactNode;
}

const FormItemRegion = ({ id, tooltipText = '', required = false, label }: IProps) => {
  const formik = useFormikContext<ExpectedAny>();

  return (
    <Autocomplete
      value={formik.values[id]}
      onChange={(_, value) => {
        formik.setFieldValue(id, value);
      }}
      onBlur={formik.handleBlur}
      id={id}
      fullWidth
      multiple={true}
      size="small"
      autoComplete
      options={REGION_PORTS}
      popupIcon={<IconFeather muiProps={{ fontSize: 'small' }} icon={<Search />} />}
      PaperComponent={PaperSelect}
      autoHighlight
      renderTags={(value: Array<string>, getTagProps) => {
        return value.map((option: string, index: number) => {
          const tagProps = getTagProps({ index });
          return <Chip variant="filled" label={option} {...tagProps} key={`region-port-${index}`} />;
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          id={id}
          name={id}
          placeholder="Typing..."
          InputLabelProps={{ required: required }}
          label={label ? label : <span>Region {tooltipText && <TooltipFormLabel title={tooltipText} />}</span>}
          error={Boolean(getFormItemError(id, formik))}
          helperText={renderFormItemError(getFormItemError(id, formik))}
        />
      )}
    />
  );
};

export default FormItemRegion;
